import { useApi } from 'services';

export const useGetPolicies = () => useApi(`/endorsements`, 'GET', {}, {});

export const useGetPoliciesExport = () => useApi(`/report/endorsements/xlsx`, 'GET', {}, {});